import { render, staticRenderFns } from "./cloudTelephony.vue?vue&type=template&id=323a7c5c"
import script from "./cloudTelephony.vue?vue&type=script&lang=js"
export * from "./cloudTelephony.vue?vue&type=script&lang=js"
import style0 from "./cloudTelephony.vue?vue&type=style&index=0&id=323a7c5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports